<template>
    <div>

		<div class="title">
			<p class="main">Everything is Tuberculosis by John Green</p>
			<div class="subheadings">
				<p class="published-date">2nd April 2025</p>
				
				
			</div>
		</div>

		<div class="article">
			<p>Reading about TB has become a bit of an obsession of mine over the last couple of years and that is partly because I watched a video in the middle of last year by John Green, author of Everything Is Tuberculosis where he quoted some terrifying stats from last years favourite Phantom Plague (the only book I actually recommended to anyone last year) and pointed at some further reading.</p>

			<p>I won’t rehash the stats and the book is not especially long so I don’t have a huge amount to say about it that hasn’t been said elsewhere - and that I haven’t said in previous reviews. Something I will credit Green with though that really stands out is his attempt to humanise this problem. He frames his discussions of the challenges in treating TB through the story of one boy - Henry - in Sierra Leone. He talks of the difficulty of simply getting hold of medicine; of ensuring that medicine is correct because not all strains of TB respond to all antibiotics; of his family pulling Henry out of treatment because they see only expense and no success. It’s refreshing to read a story  about disease and not a manifesto. Albeit the manifestos are incredibly important.</p>

			<p>Green focusses a lot on the romanticisation of disease in general and TB in particular. How it influenced fashion like shorter skirts, the cowboy hat, and pale makeup. How it was seen initially as a disease of the artist, and then of the dirty. One startling fact is that in the late 1800s, American doctors were still saying that black Americans could not contract TB as they lacked the intellect for this romantic affliction. This isn’t a history of disease or even really a history of TB - it’s a book about how we think about disease and react to the ill as a social order. There’s nothing really here on Robert Koch discovering TB (though there is some) and there’s less on the evolution of germ theory and Semmelweis but that’s intentional. Green is asking a different question to “How did we get to this situation?” he’s asking “Why are we <i>still</i> in this situation?”</p>

			<p>It’s become almost cliché to say that people don’t really die of TB, they die of poverty. But it is ultimately true. We can cure TB and with the right infrastructure it’s not even that hard or that expensive. It’s time consuming, and it requires care, but we know how to do it. We’re choosing not to treat people in developing nations with TB and we could choose to instead. As Green says at the close “Ultimately, we are the cause. We also need to be the cure”.</p>
		</div>


    </div>
</template>


<script>

	export default {
		name: "EverythingIsTBArticle"
	}

</script>


<style>

</style>